import React, { useEffect } from "react";
import _ from "lodash";
import cx from "classnames";
import Actions from "../../../../components/actionbar";
import { useTransition, animated } from "@react-spring/web";
import { useNavigate } from "react-router-dom";
import DefaultUserProfileImage from 'src/legacy/images/default_user_profile_background.png';


import styles from "./hubMenuBar.module.scss";
import { SwitchLayout } from "../switchLayout";
import Reveal from "src/components/animation";
import Button from "src/components/button";
import { NotificationSlider } from "../notificationSlider/index";
import { CreateStream } from "../createStream";
import Slider from "src/components/slider";
import { CreateAssetFileType } from "src/types/hub";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "src/redux/store";
import { fetchAllHubLayouts, cloneHubLayout } from "src/redux/actions/hub";
import { useStoreState } from "src/pages/contentMap";
import { IUseFetchProps, useFetch } from "src/components/hooks/useFetch";

import { useContentMapAdoption } from "src/redux/actions/adoption/contentMap";
import { useHubAdoption } from "src/redux/actions/adoption/hub";
import subscriptionPlanService from "src/utils/subscriptionPlan.service";
import userRoleService from "src/utils/userRoles.service";

const CreateAssetImg = '/images/createAsset.svg'
interface HubMenuBarProps {
  show: boolean;
  handleEdit: (value: boolean) => void;
}

export const HubMenuBar: React.FC<HubMenuBarProps> = ({ show, handleEdit }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { trackContentMapClicked } = useContentMapAdoption();

  const user = useSelector((state) => _.get(state,"users.me"))
  const activeLayout = useSelector((state: RootState) => state.hub?.item);
  const sections = useSelector((state: RootState) => state.hub?.sections);
  const notificationCount = useSelector((state: RootState) => _.get(state,"notification.notificationsCount", 0));

  const [transitions, api] = useTransition(show, () => ({
    initial: { opacity: 0, top: "0px" },
    from: { opacity: 1, top: "-90px" },
    enter: { opacity: 1, top: "0px" },
    leave: { opacity: 0, top: "-90px" },
  }));

  const [switchLayout, setSwitchLayout] = React.useState(false);
  const [showCreateAsset, setShowCreateAsset] = React.useState<boolean>(false);
  const [createAsset, setCreateAsset] = React.useState<string>("");
  const [showCreateStream, setShowCreateStream] =
    React.useState<boolean>(false);

  const [showNotificationSlider, setShowNotificationSlider] =
    React.useState(false);

  const [showCloneHubSlider, setShowCloneHubSlider] = React.useState(false);
  const layouts = useSelector((state: any) => _.get(state, "hub.layouts"));
  const seekEnabled = useSelector((state: any) =>
    _.get(state, "accounts.item.seekEnabled"),
  );

  const { loading: isHubUpdating, error: hubError, succeeded: isHubUpdated } = useStoreState("hub.update", false);

  const cloneHubProps: IUseFetchProps = {
    action: cloneHubLayout,
    loading: isHubUpdating,
    succeeded: isHubUpdated,
    response: activeLayout,
    error: hubError
  }

  const { handleFetch : cloneHub } = useFetch(cloneHubProps);
  const { trackHubCreateStreamClickedEvent,trackCloneHubClickedEvent, 
    trackEditHubClickedEvent,trackAssetTypeSelected,  trackHubSwitchClickedEvent, trackHubClonedEvent, trackCreateAssetClickedEvent } = useHubAdoption();

  useEffect(() => {
    api.start();
  }, [show]);

  useEffect(() => {
    const route = CreateAssetFileType[createAsset];
    if (route && _.size(route) > 0) {
      trackAssetTypeSelected(createAsset as CreateAssetFileType);
      setShowCreateAsset(false);
      // wait for slider to close
      _.delay(() => {
        navigate(`/hub/create-asset/${_.lowerCase(route)}`);
      }, 500);
    }
  }, [createAsset]);

  const handleCloneHub = () => {

    var hubLayoutRows = activeLayout.rows.map(row => {
      var columns = row.columns.map(column => {
        var section = sections[column.section.id];
        if (section.items != null && section.items.length > 0) {
          return {
            section: {
              id: column.section.id,
              title: _.get(column, "section.title") || null,
              contentIds: _.map(section.items, 'id'),
              smartFilter: section.smartFilter,
              entityType: _.toUpper(section.items[0].entityType),
              layoutStyle: _.get(column, "section.layoutStyle") || null,
              cardStyle: _.get(column, "section.cardStyle") || null
            },
            width: column.width
          }
        } else {
          return {
            section: {
              id: column.section.id,
              title: _.get(column, "section.title") || null,
              smartFilter: section.smartFilter,
              entityType: _.get(column, "section.entityType"),
              layoutStyle: _.get(column, "section.layoutStyle") || null,
              cardStyle: _.get(column, "section.cardStyle") || null
            }
          }
        }
      });
      return {
        columns: columns
      }
    });

    var layout = {
      name: `${_.get(activeLayout, "name")}(cloned)`,
      rows: hubLayoutRows,
    }
 
    cloneHub({ id: _.get(activeLayout, "id")}).then((response) => {
      trackHubClonedEvent(_.get(response,"name", ""));
      setShowCloneHubSlider(false);
      localStorage.setItem("hubLayout", response?.id);
      navigate(`/hub/layout/${response?.id}`);
      dispatch(fetchAllHubLayouts(false));
    })
  }


  return transitions(
    (style, item) =>
      item && (
        <animated.div style={style} className={cx(styles.hubMenuBar)}>
          <Actions.Container>
            <Actions.Row>

              <Actions.IconButton
                icon="paperflite-search"
                tooltip="Search"
                onClick={() => navigate("/hub/search")}
                scale={1.25}
              />
              {seekEnabled && (
                <Actions.Seek scale={1.25} />
              )}
              
              {userRoleService.canCreateStream() &&
              <Actions.IconButton
                icon="paperflite-add"
                tooltip="Create Stream"
                onClick={() => {
                  trackHubCreateStreamClickedEvent();
                  setShowCreateStream(true)}
                }
                scale={1.25}
              /> 
              }
              <div className={styles.notification}>
                <Actions.IconButton
                  icon="paperflite-notifications"
                  tooltip={`Notifications ${ notificationCount > 0 ? `(${notificationCount})` : "" }`} 
                  onClick={() => setShowNotificationSlider(true)}
                  scale={1.25}
                />
                {notificationCount > 0 && <span className={styles.notificationCount}/>}
              </div>
              <div className={styles.userAvatar}>
                <img src={_.get(user, "icon.full", DefaultUserProfileImage)} />
              </div>

            </Actions.Row>
            <Actions.Row>
              {_.size(layouts) > 1 && (
                <Actions.IconButton
                  icon="paperflite-reverse"
                  tooltip="Switch Layout"
                  onClick={() => {
                    trackHubSwitchClickedEvent();
                    setSwitchLayout(true)}
                  } 
                  scale={1.25}
                />)}
                {userRoleService.canEditLayout() &&
                <>
                <Actions.IconButton
                  icon="paperflite-edit"
                  tooltip="Edit Hub"
                  onClick={() => {
                    trackEditHubClickedEvent();
                    handleEdit(true)
                  }}
                  scale={1.25}
                />

                {userRoleService.canCloneHub() && _.size(layouts) + 1 <= subscriptionPlanService.fetchCustomHubLimit() && <Actions.IconButton
                  icon="paperflite-clone"
                  tooltip="Clone hub"
                  onClick={() => {
                    trackCloneHubClickedEvent();
                    setShowCloneHubSlider(true)
                  }
                  }
                  scale={1.25}
                />}
                {userRoleService.canAccessContentMap() &&
                <Actions.IconButton
                  icon="paperflite-content-map"
                  tooltip="Content Map"
                  onClick={() => {
                    trackContentMapClicked();
                    navigate("/hub/content-map/all");
                  }} 
                  scale={1.25}
                />
                }
              </>
              }
              
              {userRoleService.canCreateAsset() &&
              <Actions.IconButton
                icon="paperflite-add-document"
                tooltip="Create Asset"
                onClick={() => {
                  trackCreateAssetClickedEvent();
                  setShowCreateAsset(true)}
                }
                scale={1.25}
              />
              }
              
            </Actions.Row>
          </Actions.Container>
          <SwitchLayout
            show={switchLayout}
            onClose={() => setSwitchLayout(false)}
          />
          <NotificationSlider
            show={showNotificationSlider}
            onClose={() => setShowNotificationSlider(false)}
          />

          <CreateStream
            show={showCreateStream}
            onClose={() => setShowCreateStream(false)}
          />

          <Slider.Dialog
            show={showCreateAsset}
            width="300"
            onClose={() => setShowCreateAsset(false)}
          >
            <Slider.Header
              title={<>what are you creating?</>}
              message="choose how to save your new asset"
            >
              <i
                onClick={() => {
                  setShowCreateAsset(false);
                }}
                className={cx("paperflite-close", styles.closeIcon)}
              />
            </Slider.Header>

            <Slider.Body>
              <div className={styles.createAsset}>
                <img src={CreateAssetImg} />

                <div className={styles.content}>
                  <div
                    className={styles.type}
                    onClick={() => setCreateAsset(CreateAssetFileType.PDF)}
                  >
                    <i className="paperflite-radio-button-unselected" />
                    <span className={styles.header}>PDF</span>
                    <p className={styles.subText}>
                      Pick pages from PDFs and PPTX
                    </p>
                  </div>

                  <div
                    className={styles.type}
                    onClick={() => setCreateAsset(CreateAssetFileType.PPTX)}
                  >
                    <i className="paperflite-radio-button-unselected" />
                    <span className={styles.header}>PPTX</span>
                    <p className={styles.subText}>
                      Pick slides from only PPTX
                    </p>
                  </div>
                </div>
              </div>
            </Slider.Body>
          </Slider.Dialog>

          <Slider.Dialog show={showCloneHubSlider} width="300" onClose={() => setShowCloneHubSlider(false)}>
            <Slider.Header
              title={<>playing copycats, are we?</>}
              message={`clone this hub "${_.get(activeLayout, "name")}" faster than you can say 'build from scratch’"`}
            >
            </Slider.Header>
            <Slider.Body>
            </Slider.Body>

            <Slider.Actions>
              <Button icon="paperflite-tick" variant="primary" text={isHubUpdating ? "Cloning..." : "Clone"} disabled={isHubUpdating} onClick={handleCloneHub}></Button>
              <Button variant="secondary" text="Cancel" disabled={isHubUpdating} onClick={() => setShowCloneHubSlider(false)}></Button>
            </Slider.Actions>

          </Slider.Dialog>

        </animated.div>
      ),
  );
};

interface EditHubMenuBarProps {
  show: boolean;
  onSave: () => void;
  onCancel: () => void;
  disabled: boolean
}

export const EditHubMenuBar: React.FC<EditHubMenuBarProps> = ({
  show,
  onCancel,
  onSave,
  disabled
}) => {
  return (
    <Reveal show={show} className={styles.editConfirmation}>
      <div className={styles.message}>Nice save! Your changes are locked in</div>
      <Button variant="primary" disabled={disabled} text="Exit" icon="paperflite-tick" onClick={onSave}></Button>
    </Reveal>
  );
};
